let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yryI"), load("7Creg"), load("kdNTc")]).then(() => parcelRequire('k9sQt'));